<template></template>

<script>
export default {
  data: function () {
    return {};
  },

  props: ["updateUrl", "stripeKey"],

  mounted() {
    let self = this;
    setTimeout(function () {
      self.stripe = Stripe(self.stripeKey);
      self.setUpStripePay();
    }, 3000);
  },

  methods: {
    /* Start Stripe functionality */
    setUpStripePay() {
      const stripe = Stripe(this.stripeKey);
      const elements = stripe.elements();

      const cardElement = elements.create("card", { hidePostalCode: true });
      cardElement.mount("#card_number");

      const cardName = document.getElementById("card_name");
      const country = document.getElementById("card_country");
      const cardButton = document.getElementById("card_button");
      const clientSecret = cardButton.dataset.secret;

      cardName.disabled = false;

      cardButton.addEventListener("click", async (e) => {
        cardButton.disabled = true;
        $("#updateCardModal").modal({ backdrop: "static", keyboard: false });

        const billingDetails = {
          name: cardName.value,
          address: {
            country: country.value,
          },
        };

        const { setupIntent, error } = await stripe.confirmCardSetup(
          clientSecret,
          {
            payment_method: {
              card: cardElement,
              billing_details: billingDetails,
            },
          }
        );

        if (error) {
          console.log(error);
          document.getElementById("card_error").innerHTML = error.message;
          $("#updateCardModal").modal("hide");
        } else {
          document.getElementById("card_error").innerHTML = "";

          let postData = {};
          postData.payment_id = setupIntent.payment_method;
          postData.billing_details = billingDetails;

          axios
            .post(this.updateUrl, postData)
            .then((response) => {
              $("#updateCardModal").modal("hide");
              if (response.data.error) {
                document.getElementById("card_error").innerHTML =
                  response.data.message;
              } else {
                this.$root.$refs.toastr.s(response.data.message);
                setTimeout(function () {
                  location.reload();
                }, 3000);
              }
            })
            .catch((error) => {
              console.log(error);
              $("#updateCardModal").modal("hide");
              document.getElementById("card_error").innerHTML =
                error.response.message;
            });
        }

        cardButton.disabled = false;
      });

      cardName.addEventListener("keyup", (event) => {
        this.checkInput(cardName, cardButton);
      });
    },

    checkInput(cardName, cardButton) {
      if (cardName.value != "") {
        cardButton.disabled = false;
      } else {
        cardButton.disabled = true;
      }
    },
  },
};
</script>
